<script>
export default {
  name: "ManualDownload"
}
</script>
<template></template>
